import Carousel from "@/components/Carousel";
import Grid from "@/components/Grid";
import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import PickupListRow from "@/components/Row/PickupListRow/index";
import Slider from "@/components/Slider";
import { GRID_PAGE_LIMIT, LIST_PAGE_LIMIT } from "@/lib/constants";

export default function PaletteContent({
  id,
  viewType = "slider",
  header,
  items,
  largeCard,
  ...result
}) {
  return (
    <>
      {viewType === "carousel" && (
        <Carousel key={`palette-${id}-carousel`} items={items.data} />
      )}
      {viewType === "slider" && (
        <Slider
          key={`palette-${id}-slider`}
          {...result}
          header={header}
          items={items}
          largeCard={largeCard}
        />
      )}
      {viewType === "grid" && (
        <Grid
          key={`palette-${id}-grid`}
          {...result}
          viewTypeClassName={viewType}
          header={header}
          items={items}
          limit={GRID_PAGE_LIMIT}
        />
      )}
      {viewType === "pickuplist" && (
        <List
          key={`palette-${id}-pickuplist`}
          {...result}
          viewTypeClassName={viewType}
          header={header}
          itemComponent={PickupListRow}
          items={items}
          limit={LIST_PAGE_LIMIT}
        />
      )}
      {viewType === "list" && (
        <List
          key={`palette-${id}-list`}
          {...result}
          viewTypeClassName={viewType}
          header={header}
          itemComponent={ListRow}
          items={items}
          limit={LIST_PAGE_LIMIT}
        />
      )}
    </>
  );
}
